"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _sectionFilterItem = _interopRequireDefault(require("../section-filter-item"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    background: "#ffffff",
    bottom: "calc(env(safe-area-inset-bottom) + 75px)",
    left: 0,
    overflow: "auto",
    position: "fixed",
    top: "calc(env(safe-area-inset-top) + 135px)",
    width: 40
  }
}));
const SectionFilter = _ref => {
  let {
    allOptions,
    availableOptions = [],
    children,
    selected,
    onChange
  } = _ref;
  const css = useStyles();
  const handleChange = item => {
    onChange(item);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: css.root
  }, children, allOptions.map(item => {
    const {
      id,
      value
    } = item;
    return /*#__PURE__*/_react.default.createElement(_sectionFilterItem.default, {
      item: item,
      selected: value === selected,
      onChange: item => handleChange(item),
      key: id,
      disabled: !!availableOptions.length ? !availableOptions.includes(value) : false
    });
  }));
};
var _default = exports.default = SectionFilter;